import { TQueryOption } from '@src/modules/option'
import { LANGUAGE_DEFAULT } from '@src/configs/const.config'

import { request } from './config'

export const createOption = (data: any, token: string) => request({ url: 'option', method: 'POST', data }, { token })
export const getOptionByKeys = (params: TQueryOption, token: string, lang = LANGUAGE_DEFAULT) =>
  request({ url: 'option/keys', method: 'GET', params }, { token, lang })
